/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './diaglab-equipment.reducer';

export const DiaglabEquipment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const diaglabEquipmentList = useAppSelector(state => state.diaglabEquipment.entities);
  const loading = useAppSelector(state => state.diaglabEquipment.loading);
  const totalItems = useAppSelector(state => state.diaglabEquipment.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="diaglab-equipment-heading" data-cy="DiaglabEquipmentHeading">
        <Translate contentKey="tinyMedicRestApp.diaglabEquipment.home.title">Diaglab Equipments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.diaglabEquipment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/diaglab-equipment/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.diaglabEquipment.home.createLabel">Create new Diaglab Equipment</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.diaglabEquipment.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {diaglabEquipmentList && diaglabEquipmentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('aeTitle')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.aeTitle">Ae Title</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('aeTitle')} />
                </th>
                <th className="hand" onClick={sort('supended')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.supended">Supended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('supended')} />
                </th>
                <th className="hand" onClick={sort('mfdDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.mfdDate">Mfd Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mfdDate')} />
                </th>
                <th className="hand" onClick={sort('dateSupended')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.dateSupended">Date Supended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dateSupended')} />
                </th>
                <th className="hand" onClick={sort('reasonSupended')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.reasonSupended">Reason Supended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reasonSupended')} />
                </th>
                <th className="hand" onClick={sort('maintainanceCycle')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.maintainanceCycle">Maintainance Cycle</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maintainanceCycle')} />
                </th>
                <th className="hand" onClick={sort('lastMaintenanceDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.lastMaintenanceDate">Last Maintenance Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastMaintenanceDate')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('mwl')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.mwl">Mwl</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mwl')} />
                </th>
                <th className="hand" onClick={sort('underMaintainance')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.underMaintainance">Under Maintainance</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('underMaintainance')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.equipment">Equipment</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabEquipment.diagLab">Diag Lab</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {diaglabEquipmentList.map((diaglabEquipment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/diaglab-equipment/${diaglabEquipment.id}`} color="link" size="sm">
                      {diaglabEquipment.id}
                    </Button>
                  </td>
                  <td>{diaglabEquipment.name}</td>
                  <td>{diaglabEquipment.aeTitle}</td>
                  <td>{diaglabEquipment.supended ? 'true' : 'false'}</td>
                  <td>{diaglabEquipment.mfdDate}</td>
                  <td>{diaglabEquipment.dateSupended}</td>
                  <td>{diaglabEquipment.reasonSupended}</td>
                  <td>{diaglabEquipment.maintainanceCycle}</td>
                  <td>{diaglabEquipment.lastMaintenanceDate}</td>
                  <td>{diaglabEquipment.active ? 'true' : 'false'}</td>
                  <td>{diaglabEquipment.cursor}</td>
                  <td>{diaglabEquipment.lastUpdated}</td>
                  <td>{diaglabEquipment.microSec}</td>
                  <td>{diaglabEquipment.timestampEntry}</td>
                  <td>{diaglabEquipment.mwl ? 'true' : 'false'}</td>
                  <td>{diaglabEquipment.underMaintainance ? 'true' : 'false'}</td>
                  <td>
                    {diaglabEquipment.equipment ? (
                      <Link to={`/equipment/${diaglabEquipment.equipment.id}`}>{diaglabEquipment.equipment.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diaglabEquipment.diagLab ? (
                      <Link to={`/diag-lab/${diaglabEquipment.diagLab.id}`}>{diaglabEquipment.diagLab.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/diaglab-equipment/${diaglabEquipment.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/diaglab-equipment/${diaglabEquipment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/diaglab-equipment/${diaglabEquipment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.diaglabEquipment.home.notFound">No Diaglab Equipments found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={diaglabEquipmentList && diaglabEquipmentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DiaglabEquipment;
